
seedWebControllers.controller('IntegrationScopeController', ['$scope', '$filter', '$uibModal', '$window', '$location', '$routeParams', 'IntegrationScopeService', 'moment', 'ToastService', '$mdSidenav', '$mdDialog',
    function ($scope, $filter, $uibModal, $window, $location, $routeParams, IntegrationScopeService, moment, ToastService, $mdSidenav, $mdDialog) {
        $scope.moduleName = 'Integrations';

        $scope.integrationID = $routeParams.id;
        $scope.scopeID = $routeParams.scopeID;
        $scope.isBusy = false;

        $scope.resetPristine = function () {
            $scope.frmScope.$setPristine();
        };

        $scope.integrationScopeService = IntegrationScopeService;

        $scope.loadScope = function (fullReload) {
            $scope.isBusy = true;
            $scope.loading = true;
            IntegrationScopeService.getScope($scope.scopeID).then(function (result) {
                var data = result.data;
                $scope.scopeItem = data;
                $scope.isBusy = false;
                $scope.loading = true;
                $scope.loadQueues(fullReload);
            }, function () {
                $scope.isBusy = false;
                $scope.loading = true;
            });
        };

        $scope.editIntegrationModal = function (id) {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/EditAdminIntegration.html',
                controller: 'EditAdminIntegrationCtrl',
                size: 'lg',
                resolve: {
                    integrationID: function () { return id; }
                }
            });

            modalInstance.result.then(function (action) {
                if(action == 'DELETE') {
                    ToastService.createToast('Integração deletada com sucesso!', '', 8000, 'success');
                    $scope.goList();
                } else {
                    ToastService.createToast('Integração salva com sucesso!', '', 4000, 'success');
                    $scope.loadScope();
                }
            });

        };

        $scope.skipNumber = 0;
        $scope.takeNumber = 5;

        $scope.loadQueues = function (fullReload) {
            $scope.isBusy = true;
            if (fullReload) {
                $scope.skipNumber = 0;
            }

            IntegrationScopeService.getScopeQueues($scope.scopeID, $scope.skipNumber, $scope.takeNumber).then(function (data) {
                if ($scope.scopeQueues && !fullReload) {                 
                    $scope.scopeQueues = $scope.scopeQueues.concat(data);
                }
                else {
                    $scope.scopeQueues = angular.copy(data);                    
                }
                $scope.skipNumber += data.length;
                if (data.length === 0){
                    $scope.noMoreData = true;
                }
                $scope.isBusy = false;
                $scope.scopeQueues[0].show = true;
                $scope.show = true;
            }, function () {
                $scope.isBusy = false;
            });

        };

        $scope.filterLogError = function (log) {
            return log.LogType == 'Error';
        };

        $scope.loadProperty = function (ev, propertyToRead) {
            console.log('loadProperty');

            $scope.isBusy = true;
            IntegrationScopeService.getProperty($scope.scopeID, propertyToRead).then(function (result) {
                var data = result.data;
                $scope.scopeItem[propertyToRead] = data[propertyToRead];
                $scope.isBusy = false;
                $scope.showEditModal(ev, propertyToRead);
            }, function () {
                $scope.isBusy = false;
            });
        };

        $scope.loadScopeValues = function (ev, propertyToRead) {
            $scope.isBusy = true;

            IntegrationScopeService.getScopeValues($scope.scopeID).then(function (result) {
                var data = result.data;
                $scope.scopeItem.ScopeValues = data.ScopeValues;
                $scope.isBusy = false;
                $scope.showEditModal(ev, propertyToRead);
            }, function () {
                $scope.isBusy = false;
            });

        };

        $scope.loadProcessedValues = function (ev, propertyToRead) {
            $scope.isBusy = true;
            IntegrationScopeService.getProcessedValues($scope.scopeID).then(function (data) {
                $scope.scopeItem.ProcessedValues = data.ProcessedValues;
                $scope.isBusy = false;
                $scope.showEditModal(ev, propertyToRead);
            }, function () {
                $scope.isBusy = false;
            });

        };

        $scope.loadDecodedValues = function (ev, propertyToRead) {
            $scope.isBusy = true;

            IntegrationScopeService.getDecodedValues($scope.scopeID).then(function (data) {
                $scope.scopeItem.DecodedValues = data.DecodedValues;
                $scope.isBusy = false;
                $scope.showEditModal(ev, propertyToRead);
            }, function () {
                $scope.isBusy = false;
            });

        };

        $scope.loadScope();

        $scope.reload = function () {
            IntegrationScopeService.resetCache();
            $scope.loadScope(true);
            $scope.noMoreData = false;
        };

        $scope.goList = function () {
            $location.path('/Integrations/');
        };

        $scope.actionBack = function () {
            $location.path('/Integrations/IntegrationScopes/'+$scope.integrationID);
        };

        $scope.save = function () {
            $scope.isBusy = true;


            console.log('SAVE [' + $scope.scopeItem.ScopeValues + ']');

            IntegrationScopeService.save($scope.scopeItem).then(function () {
                $scope.isBusy = false;
            }, function () {
                $scope.isBusy = false;
            });
        };

        $scope.update = function (valueToUpdate) {
            $scope.isBusy = true;
            IntegrationScopeService.update(valueToUpdate).then(function (data) {
                $scope.isBusy = false;
                angular.extend($scope.scopeItem, data);
            }, function () {
                $scope.isBusy = false;
            });
        };

        $scope.processScope = function () {
            $scope.isBusy = true;
            var toastID = ToastService.createToast('', 'Processando a Integração', 0, 'wait');
            IntegrationScopeService.processData($scope.scopeID).then(
                function (result) {
                     var data = result.data;
                    $scope.scopeItem.Logs = data;
                    $scope.skipNumber += 1;
                    $scope.isBusy = false;
                    $scope.reload();
                    ToastService.removeToast(toastID);
            }, function (error) {
                    $scope.isBusy = false;
                    var errorDescription = error.statusText;
                    ToastService.updateToast(toastID, 'Erro ao processar integração', errorDescription, 8000, 'error');
            });
        };

        $scope.closeQueues = function () {
            angular.forEach($scope.scopeQueues, function (item) {
                item.show = false;
                item.sectionWhiteframe = -1;
            });
        };

        $scope.toggleQueue = function (queue) {
            var originalShow = queue.show;
            $scope.closeQueues();
            queue.show = !originalShow;
            if (queue.show) {
                queue.sectionWhiteframe = 6;
            }
        };
        

        $scope.toggleEdit = function () {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/scopeEditName.html',
                controller: 'ScopeEditNameController',
                size: 'md',
                resolve: {
                    scopeItem: function () { return $scope.scopeItem; },
                    translation: function () { return $scope.translation;}
                }
            });

            modalInstance.result.then(function (item) {
                $scope.update(item);
            });

        };


        $scope.showEditModal = function (ev, propertyToRead) {
            var modalInstance = $uibModal.open({
                templateUrl: '/SPA/Integrations/scopeEditValues.html',
                controller: 'ScopeEditValuesController',
                size: 'xl',
                resolve: {
                    scopeItem: function () { return $scope.scopeItem; },
                    propertyToRead: function () { return propertyToRead; },
                    translation: function () { return $scope.translation; }
                }
            });

            modalInstance.result.then(function (scopeItem) {
                IntegrationScopeService.resetCache();            
                $scope.update(IntegrationScopeService.updatePreviewValues(scopeItem));
            });
        };

        $scope.editModal = function (ev, propertyToRead) {
            if ($scope.isBusy) {
                return null;
            }
            if (propertyToRead === 'RequestBody') {
                $scope.loadProperty(ev, propertyToRead);
            }
            else if (propertyToRead === 'ScopeValues') {
                $scope.loadScopeValues(ev, propertyToRead);
            }
            else if (propertyToRead === 'ProcessedValues') {
                $scope.loadProcessedValues(ev, propertyToRead);
            }
            else {
                $scope.loadDecodedValues(ev, propertyToRead);
            }
        };

       
        $scope.getIconLog = function (type) {
            if (type === 'Error') {
                return 'error_outline';
            } else if (type === 'Warning') {
                return 'warning';
            }
            if (type === 'Info') {
                return 'info_outline';
            } else {
                return 'done';
            }
        };

        $scope.$on('onIntegrationProcess',
            function (event, data) {
                $scope.reload();
            }
        );

        $scope.isRunning = function (item) {
            return item.Status != 'Ok' && item.Status != 'Error' && item.Status != 'Pending';
        };
    }]);